import http from 'plugins/axios'

export default {
  mockList(data) {
    return http.get({
      url: '/ta/admin/mock/wallet/mock/list',
      data,
    })
  },

  mockDeposit(data) {
    return http.post({
      url: '/ta/admin/mock/wallet/mock/deposit',
      data,
      dataType: 'form',
    })
  },

  mockWithdraw(data) {
    return http.post({
      url: '/ta/admin/mock/wallet/mock/withdraw',
      data,
      dataType: 'form',
    })
  },
  mockRebate(data) {
    return http.post({
      url: '/ta/admin/rebate/mockRebate',
      data,
      dataType: 'form',
    })
  },
}
